<template lang="pug">
  v-dialog(v-model="$_show" content-class="sud-dialog" scrollable persistent :width="width" light)
    template(v-slot:activator="{ on }") 
      slot(v-if="$slots.activator" name="activator" v-on="on")

    v-card.sud-dialog-card
      v-card-title.sud-dialog-card__header
        v-layout(align-center)
          v-flex {{ header }}
          v-flex(v-if="closeButtonHidden == false" shrink)
            v-btn.mr-0.sud-dialog-card__header-close(icon @click="$_show = false")
              v-icon(size="24" color="#C4C4C4") cancel

      slot(v-if="$slots.prepend" name="prepend")

      v-card-text.sud-dialog-card__body
        slot
          app-list(:items="items" @select="handleItem")
          
        slot(name="footer")
          .sud-dialog-card__footer(v-if="confirmText")
            v-btn.text-none.sud-dialog-card__action(
              :disabled="confirmDisabled" 
              :dark="confirmDisabled == false"
              color="#1B93AD" 
              large depressed 
              @click="handleConfirm") {{ confirmText }}
</template>

<script>
import AppDialogToggable from './AppDialogToggable'
import AppList from './AppList'

export default {
  mixins: [AppDialogToggable],
  name: 'app-dialog',

  components: {
    AppList
  },

  props: {
    header: {
      type: String,
      default: ''
    },
    closeButtonHidden: Boolean,
    width: {
      type: [String, Number],
      default: 378
    },
    confirmText: String,
    confirmDisabled: Boolean,
    items: Array
  },

  methods: {
    handleConfirm () {
      this.$_show = false
      this.$emit('confirm')
    },
    handleItem (item, index) {
      this.$_show = false
      this.$emit('select', item, index)
    }
  }
}
</script>

<style>
.sud-dialog {
  border-radius: 5px !important;
  overflow: auto;
}
</style>

<style lang="scss" scoped>
.sud-dialog-card {
  background: transparent !important;
}

.sud-dialog-card__header {
  // background: $base-color;
  background: #959595;
  padding: 24px 16px;

  font-family: 'Roboto Slab', serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 16px;

  color: #FFFFFF;
}
.sud-dialog-card__header-close {
  outline: none !important;
}

.sud-dialog-card__body {
  padding: 24px 16px 24px !important;
  background: #FFFFFF;
}

.sud-dialog-card__footer {
  text-align: right;
  padding-top: 16px;
}

.sud-dialog-card__action {
  margin: 0px;

  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #FFFFFF;
}
</style>